import { Chip } from "@mui/material";
import { useState } from "react";
import { ISinisterCaseStatusEntry, SinisterNegotiationService } from "../../../shared/services/api/sinister/SinisterNegotiationService";
import { CASE_STATUS_OPEN_LABEL, getCaseStatusChipColors, getCaseStatusLabel } from "../constants/caseStatusOptions";
import { ModalCaseStatusHistory } from "./Modals/ModalCaseStatusHistory";

interface Props {
	sinisterId: string;
	caseStatus?: string | null;
}

// Chip clicável: ao clicar, busca e mostra o histórico de status da cobrança desse sinistro.
// Sem status registrado ainda ("Aberto") também é clicável — só vai mostrar histórico vazio.
export const CreditRecoveryStatusCell = ({ sinisterId, caseStatus }: Props) => {
	const [openHistory, setOpenHistory] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [history, setHistory] = useState<ISinisterCaseStatusEntry[]>([]);

	const handleOpenHistory = async () => {
		setOpenHistory(true);
		setIsLoading(true);
		const result = await SinisterNegotiationService.getCaseStatusHistory(sinisterId);
		if (!(result instanceof Error)) setHistory(result);
		setIsLoading(false);
	};

	const colors = getCaseStatusChipColors(caseStatus);

	return (
		<>
			<Chip
				size="medium"
				clickable
				onClick={handleOpenHistory}
				label={caseStatus ? getCaseStatusLabel(caseStatus) : CASE_STATUS_OPEN_LABEL}
				sx={{ fontWeight: 500, bgcolor: colors.bg, color: colors.color, border: "0.5px solid #f1f1f1" }}
			/>

			<ModalCaseStatusHistory open={openHistory} entries={history} isLoading={isLoading} onClose={() => setOpenHistory(false)} />
		</>
	);
};
